export default __webpack_public_path__ + "static/media/neck-purple.45486efc.png";